(() => {
  if (!document.body.classList.contains('dn-page')) return;
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let revealObserver;
  let haloObserver;
  const stopObservers = () => {
    revealObserver?.disconnect();
    haloObserver?.disconnect();
    document.querySelectorAll('.dn-reveal-pending,.dn-halo-pending').forEach(el => el.classList.remove('dn-reveal-pending', 'dn-halo-pending'));
  };
  const initialize = () => {
    stopObservers();
    if (motion.matches || !('IntersectionObserver' in window)) return;
    revealObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.remove('dn-reveal-pending');
        revealObserver.unobserve(entry.target);
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -20px 0px' });
    document.querySelectorAll('[data-dn-reveal]').forEach(el => {
      if (el.getBoundingClientRect().top < window.innerHeight) return;
      const siblings = [...el.parentElement.children].filter(child => child.hasAttribute('data-dn-reveal'));
      el.style.setProperty('--dn-delay', `${Math.min(siblings.indexOf(el), 3) * 80}ms`);
      el.classList.add('dn-reveal-ready', 'dn-reveal-pending');
      revealObserver.observe(el);
    });
    const halo = document.querySelector('.dn-night-halo');
    if (halo && halo.getBoundingClientRect().top > window.innerHeight) {
      halo.classList.add('dn-halo-pending');
      haloObserver = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          halo.classList.remove('dn-halo-pending');
          haloObserver.disconnect();
        }
      }, { threshold: 0.2 });
      haloObserver.observe(document.querySelector('.dn-night-photo'));
    }
  };
  document.addEventListener('click', event => {
    if (event.target.closest('.dn-mobile-menu a')) event.target.closest('details').removeAttribute('open');
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const menu = document.querySelector('.dn-mobile-menu[open]');
    if (menu) { menu.removeAttribute('open'); menu.querySelector('summary').focus(); }
  });
  motion.addEventListener('change', initialize);
  document.addEventListener('shopify:section:load', initialize);
  initialize();
})();
